module.exports = __webpack_public_path__ + "images/saaremaa/routes/PAP-VIK-PAP.png";